import styled from 'styled-components';
import colors from 'theme/colors';

export const BlockContent = styled.div`
    background: ${colors.neutralLight};
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 22px;
    border: 1px solid #ccc;

    ${({ smallPadding }) => smallPadding && `
        padding: 6px 8px;
    `}
`;